import React from 'react';

// Section des partenaires officiels - SAP et URSSAF avec vrais logos
export const PartnersLogos = () => {
  return (
    <section className="py-12 bg-gradient-to-b from-[#d4e6d1] to-[#c5dbc2] font-['Poppins']">
      <div className="container mx-auto px-4">
        <p className="text-center text-sm text-gray-600 mb-8 uppercase tracking-wider font-medium">
          Nos partenaires officiels
        </p>
        
        <div className="flex flex-wrap items-center justify-center gap-12 md:gap-20">
          {/* Services à la Personne (SAP) - Vrai logo */}
          <div className="flex items-center opacity-90 hover:opacity-100 transition-opacity">
            <img 
              src="https://customer-assets.emergentagent.com/job_concierge-website/artifacts/fyr6pcjx_Traceur_SAP_buro_rvb_png.png"
              alt="Services à la Personne"
              className="h-16 md:h-20 w-auto object-contain"
            />
          </div>

          {/* Urssaf - Vrai logo */}
          <div className="flex items-center opacity-90 hover:opacity-100 transition-opacity">
            <img 
              src="https://customer-assets.emergentagent.com/job_concierge-website/artifacts/u7emij6n_logo-urssaf-2.png"
              alt="URSSAF"
              className="h-16 md:h-20 w-auto object-contain"
            />
          </div>

          {/* CESU - Nouveau logo */}
          <div className="flex items-center opacity-90 hover:opacity-100 transition-opacity">
            <img 
              src="https://customer-assets.emergentagent.com/job_2513ce8b-8bd6-4c11-809d-00965abc9d4a/artifacts/5w7l650a_Logo_cncesu.png"
              alt="CESU - Chèque Emploi Service Universel"
              className="h-16 md:h-20 w-auto object-contain"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
